import React from 'react';
import { useIntl } from 'react-intl';
import { Form, Input } from 'semantic-ui-react';
import {
  checkValidEmail, firstError, firstResponseError, validationClasses,
} from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import FormValidationError from '@/components/errors/FormValidationError';
import fields, { globalFieldLengths } from '@/constants/fields';
import UserGroupsDropdown from '@/users/groups/components/UserGroupsDropdown';
import { hasMinimumLength } from '@/utils/resultsHelper';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const ManageTaskDialog = ({ theme }) => {
  const intl = useIntl();
  const {
    isDirty, email, groups, name, saveErrors, saveStatus,
  } = Selectors.useManageTaskDialog();
  const hide = Events.useHideManageTask();
  const submitForm = Events.useManageRequestTask();
  const updateProperties = Events.useUpdateManageTaskProperties();
  const emailError = saveErrors.find((e) => (e.fields.includes(fields.EMAIL)));

  const onSubmit = () => {
    const errors = [];
    if (hasMinimumLength(email)) {
      checkValidEmail(email, [fields.EMAIL], errors, 'task');
    }
    updateProperties({ properties: { saveErrors: errors } });

    if (errors.length === 0) {
      submitForm();
    }
  };

  return (
    <Dialog
      className="aridhia-manage-task-dialog tinywizard"
      error={firstResponseError(saveErrors)}
      icon="cog"
      inProgress={saveStatus === states.PENDING}
      message="task.manage.message"
      minimumDataEntryMet={isDirty}
      onClose={hide}
      onDismiss={() => updateProperties({ properties: { saveErrors: [] } })}
      onSave={onSubmit}
      warning
      theme={theme}
      title={name}
    >
      <Form autoComplete="off" onSubmit={onSubmit} error={firstError(saveErrors) !== null}>
        <FormValidationError
          htmlFor="role_groupings_dropdown"
          labelId="manage.task.candidate.groups"
          position="right"
        >
          <UserGroupsDropdown
            category="tasks"
            values={groups.map(({ code }) => code)}
            disabled={saveStatus === states.PENDING}
            onChange={(e, { value }) => updateProperties({ properties: { groups: value.map((code) => ({ code })) } })}
          />
        </FormValidationError>
        <FormValidationError
          error={emailError}
          htmlFor="task_assignee"
          labelId="manage.task.assignee"
          position="right"
        >
          <Input
            className={validationClasses(emailError)}
            disabled={saveStatus === states.PENDING}
            id="task_assignee"
            maxLength={globalFieldLengths.email}
            onChange={(e, { value }) => updateProperties({ properties: { assignee: { email: value } } })}
            placeholder={intl.formatMessage({ id: 'manage.task.assignee.placeholder' })}
            size="large"
            type="custom"
            value={email}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

export default ManageTaskDialog;
